"use client";

import { useEffect, useState } from "react";

import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { useToast } from "../hooks/use-toast";
import { Skeleton } from "./ui/skeleton";
import TradePairForex from "./TradePairForex";
import QuoteDetailsForex from "../components/QuoteDetailsForex";
import TradePairSaleForex from "./TradePairSaleForex";
import AssetSaleSelectorForex from "./AssetSaleSelectorForex";
import { Tabs, TabsList, TabsTrigger } from "./ui/tabs";
import { useAuth } from "../context/AuthContext";
import pic from "../assets/images/mail.png";
import AssetSelectorForex from "../components/AssetSelectorForex";
import ForexComplete from "../components/ForexComplete";
import { currencies, pair } from "../data/mockTradeRates";
import { customQuote } from "../hooks/useTradeRate";
import { FeatureGate, useFeatureAccess } from "./FeatureGate";
import { useAvailableBalances } from "../hooks/query/queries";
import { useMemo } from "react";

export default function BuySellPageForex({
  assetToSelect,
  tab,
  quickActionTab,
  childTab,
  tradingAssets,
}) {
  const { flags: featureFlags, isLoading: isLoadingFlags } = useFeatureAccess(
    "mainFeatures",
    ["buyForex", "sellForex"]
  );
  const isBuyEnabled = featureFlags?.buyForex;
  const isSellEnabled = featureFlags?.sellForex;

  const [tradeType, setTradeType] = useState(null);
  const [amount, setAmount] = useState(null);
  const [inputAmount, setinputAmount] = useState(null);
  const [orderAmount, setOrderAmount] = useState(null);
  const [incomingAmount, setIncomningAmount] = useState(null);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedSaleAsset, setSelectedSaleAsset] = useState(null);
  const [selectedPair, setSelectedPair] = useState(null);
  const [selectedSalePair, setSelectedSalePair] = useState(null);
  const [tradeRate, setTradeRate] = useState(null);
  const [quote, setQuote] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showQuote, setShowQuote] = useState(false);
  const [order, setOrder] = useState(false);
  const [isTrading, setIsTrading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPostTrade, setIsPostTrade] = useState(false);
  const [awaitingRateParent, setAwaitingRateParent] = useState(true);
  const [awaitingSaleRate, setAwaitingSaleRate] = useState(false);
  const [awaitingRateSecondary, setAwaitingRateSecondary] = useState(false);
  const [loadingPairBuy, setLoadingPairBuy] = useState(false);
  const [isBaseInputParent, setIsBaseInputParent] = useState(false);
  const [currentPairs, setCurrentPairs] = useState(null);
  const [isPairPostTradeAllowed, setIsPairPostTradeAllowed] = useState(false);
  const { userProfile, settings } = useAuth();
  const { toast } = useToast();
  const isPostTradeAllowed = settings?.postTradeSettlements || false;

  const { data: walletAssets } = useAvailableBalances(userProfile?._id);

  const fiatBalances = useMemo(
    () =>
      walletAssets?.map((asset) => {
        return {
          asset: asset.asset,
          valueInLocalCurrency:
            asset.asset === "zar"
              ? asset.availableAmountFormatted
              : asset.valueInLocalCurrency,
        };
      }) ?? [],
    [walletAssets]
  );

  useEffect(() => {
    if (isLoadingFlags) return;
    if (tradeType !== null) return;
    if (isBuyEnabled) {
      setTradeType("Buy");
    } else if (isSellEnabled) {
      setTradeType("Sell");
    }
  }, [isBuyEnabled, isSellEnabled, tradeType, isLoadingFlags]);

  useEffect(() => {
    if (!selectedAsset?.assetId) return;
    setCurrentPairs(pair);
  }, [selectedAsset]);

  useEffect(() => {
    if (!selectedSaleAsset?.assetId) return;
    setCurrentPairs(pair);
  }, [selectedSaleAsset]);

  useEffect(() => {
    const validTabs = ["Buy", "Sell"];
    if (!tab) return;
    if (validTabs.includes(tab)) {
      setTradeType(tab);
    }
  }, [tab]);

  useEffect(() => {
    const validTabs = ["Buy", "Sell"];
    if (!childTab) return;
    if (validTabs.includes(childTab)) {
      setTradeType(childTab);
    }
  }, [childTab]);

  useEffect(() => {
    const validTabs = ["Buy", "Sell"];
    if (!quickActionTab) return;
    if (validTabs.includes(quickActionTab)) {
      setTradeType(quickActionTab);
    }
  }, [quickActionTab]);

  const handleConfirm = async (result) => {
    if (!result) {
      setLoading(true);
    }
    if (result) {
      setLoading(false);
      setShowQuote(false);
      setShowSuccess(true);
    }
  };

  const handleDone = () => {
    setSelectedSaleAsset(null);
    setSelectedAsset(null);
    setSelectedPair(null);
    setShowSuccess(false);
    window.location.reload();
  };
  const handleBack = () => {
    setShowQuote(false);
  };

  const handleAssetChange = (asset) => {
    setSelectedAsset(asset);
  };
  const handleAssetSaleChange = (asset) => {
    setAwaitingRateSecondary(true);

    setSelectedSaleAsset(asset);
  };
  const handlePairChange = (pair) => {
    setSelectedPair(pair);
  };
  const handlePairsSaleChange = (pair) => {
    setSelectedSalePair(pair);
  };
  const handleInputAmount = (outAmount, inAmount) => {
    setinputAmount(outAmount);
    setIncomningAmount(inAmount);
  };
  const handleLoadingPair = (loadingPair) => {
    setLoadingPairBuy(loadingPair);
  };
  const handleInputSaleAmount = (inAmount, outAmount) => {
    setinputAmount(inAmount);
    setIncomningAmount(outAmount);
  };
  const handleOrderBuy = (targetAmount) => {
    setOrderAmount(targetAmount);
    setOrder(true);
  };
  const handleOrderCancel = () => {
    setOrder(false);
  };

  const orderBuyData = {
    userId: userProfile?._id,
    currencyPair: selectedPair?.pair,
    incomingAsset: selectedAsset?.asset,
    outgoingAsset: selectedPair?.asset,
    orderType: "below",
    type: "buy",
    price: tradeRate?.rate,
    targetPrice: orderAmount,
    incomingAmount: incomingAmount,
    outgoingAmount: inputAmount,
    serviceFee: 0,
    brokerPercentage: 0,
    note: "",
    isPostTrade: isPostTrade,
    assetId: selectedAsset?.assetId,
  };
  const orderSellData = {
    userId: userProfile?._id,
    currencyPair: selectedSalePair?.pair,
    incomingAsset: selectedSalePair?.asset,
    outgoingAsset: selectedSaleAsset?.asset,
    orderType: "above",
    type: "sell",
    price: tradeRate?.rate,
    targetPrice: orderAmount,
    incomingAmount: inputAmount,
    outgoingAmount: incomingAmount,
    serviceFee: 0,
    brokerPercentage: 0,
    note: "",
    isPostTrade: isPostTrade,
    assetId: selectedSaleAsset?.assetId,
  };
  const buyData = {
    userId: userProfile?._id,
    tradeType: tradeType?.toLowerCase() ?? "buy",
    pair: selectedPair?.pair,
    incomingAmount: incomingAmount,
    outgoingAmount: inputAmount,
    price: tradeRate?.rate,
    serviceFee: 0,
    feePercentage: 0,
    incomingAsset: selectedAsset?.asset,
    outgoingAsset: selectedPair?.asset,
    brokerPercentage: 0,
    brokerAmount: 0,
    isPostTrade: isPostTrade,
  };

  const sellData = {
    userId: userProfile?._id,
    tradeType: tradeType?.toLowerCase() ?? "sell",
    pair: selectedSalePair?.pair,
    incomingAmount: inputAmount,
    outgoingAmount: incomingAmount,
    price: tradeRate?.rate,
    serviceFee: 0,
    feePercentage: 0,
    incomingAsset: selectedSalePair?.asset,
    outgoingAsset: selectedSaleAsset?.asset,
    brokerPercentage: 0,
    brokerAmount: 0,
    isPostTrade: isPostTrade,
  };

  const quoteData = {
    incomingAsset: selectedAsset?.asset,
    outgoingAsset: selectedPair?.asset,
    assetId: selectedAsset?.assetId,
    amount: inputAmount,
    rate: tradeRate?.rate,
    isPostTrade: isPostTrade,
    isBaseInput: isBaseInputParent,
    tradeType: tradeType?.toLowerCase() ?? "buy",
    pair: selectedAsset?.asset + "-" + selectedPair?.asset,
    isCustom: order,
    userId: userProfile?._id,
  };

  const quoteSaleData = {
    incomingAsset: selectedSalePair?.asset,
    outgoingAsset: selectedSaleAsset?.asset,
    assetId: selectedSaleAsset?.assetId,
    amount: inputAmount,
    rate: tradeRate?.rate,
    isPostTrade: isPostTrade,
    isBaseInput: isBaseInputParent,
    tradeType: tradeType?.toLowerCase() ?? "sell",
    pair: selectedSaleAsset?.asset + "-" + selectedSalePair?.asset,
    isCustom: order,
    userId: userProfile?._id,
  };

  const handleTabChange = (value) => {
    setTradeType(value);
  };

  const { getQuote } = customQuote();
  const trade = () => {
    setIsTrading(true);
    if (tradeType === "Buy") {
      const numericAmount = parseFloat(inputAmount);
      if (
        !inputAmount ||
        inputAmount === null ||
        isNaN(numericAmount) ||
        numericAmount <= 0
      ) {
        toast({
          description: "Please enter a valid amount",
          variant: "eighty",
        });
        setIsTrading(false);
        return;
      }

      try {
        const result = getQuote(quoteData);
        const resultData = result;

        setQuote(resultData);
        setShowQuote(true);
        setIsTrading(false);
      } catch (error) {
        toast({
          description: `${error}`,
          variant: "eighty",
        });
        setIsTrading(false);
      }
    }
    if (tradeType === "Sell") {
      const numericAmount = parseFloat(inputAmount);
      if (
        !inputAmount ||
        inputAmount === null ||
        isNaN(numericAmount) ||
        numericAmount <= 0
      ) {
        toast({
          description: "Please enter a valid amount",
          variant: "eighty",
        });
        setIsTrading(false);
        return;
      }

      try {
        const result = getQuote(quoteSaleData);
        const resultData = result;

        setQuote(resultData);
        setShowQuote(true);
        setIsTrading(false);
      } catch (error) {
        toast({
          description: `${error}`,
          variant: `eighty`,
        });
        setIsTrading(false);
      }
    }
  };

  const handleDisabledButton = () => {
    setAwaitingRateSecondary(false);
    setAwaitingSaleRate(false);
    setAwaitingRateParent(false);
  };

  const handleDisabledButtonSecondary = () => {
    setAwaitingRateParent(true);
  };

  useEffect(() => {
    if (!selectedPair && !selectedSalePair) return;

    const isAllowed =
      selectedPair?.postTradeEnabled ?? selectedSalePair?.postTradeEnabled;

    setIsPairPostTradeAllowed(isAllowed);
    if (!isAllowed) {
      setIsPostTrade(false);
    }
  }, [selectedPair, selectedSalePair]);
  return (
    <>
      {!showQuote && !showSuccess && (
        <Card className="flex flex-col w-full p-8 shadow-lg bg-white rounded-2xl">
          {(isBuyEnabled || isSellEnabled) && (
            <Tabs onValueChange={handleTabChange} className="mb-8">
              <TabsList
                className={`grid ${isBuyEnabled && isSellEnabled ? "grid-cols-2" : "grid-cols-1"} rounded-full h-full bg-gray-100`}
              >
                <FeatureGate flag="buyForex">
                  <TabsTrigger
                    value="Buy"
                    className={`py-3 text-lg font-semibold rounded-full transition-colors ${
                      tradeType === "Buy"
                        ? "bg-purple-900 text-white"
                        : "text-gray-600"
                    }`}
                  >
                    Buy
                  </TabsTrigger>
                </FeatureGate>
                <FeatureGate flag="sellForex">
                  <TabsTrigger
                    value="Sell"
                    className={`py-3 text-lg font-semibold rounded-full transition-colors ${
                      tradeType === "Sell"
                        ? "bg-purple-900 text-white"
                        : "text-gray-600"
                    }`}
                  >
                    Sell
                  </TabsTrigger>
                </FeatureGate>
              </TabsList>
            </Tabs>
          )}

          <div className="space-y-2">
            {tradeType === "Buy" && !showQuote && (
              <AssetSelectorForex
                currencies={currencies}
                hotActionAsset={tab === "Buy" ? assetToSelect : null}
                onTarget={handleOrderBuy}
                onTargetCancel={handleOrderCancel}
                onSelect={handleAssetChange}
                setIsBaseInputParent={setIsBaseInputParent}
                loadingPairBuy={loadingPairBuy}
                setLoadingPairBuy={setLoadingPairBuy}
                setSelectedAsset={setSelectedAsset}
                selectedAsset={selectedAsset}
                onChange={handleInputAmount}
                setAmount={setAmount}
                amount={amount}
                tradingAssets={tradingAssets}
                pair={selectedPair}
                setParentRate={setTradeRate}
                onFetcedRate={handleDisabledButton}
                onSelectedAsset={handleDisabledButtonSecondary}
                onReject={() => setIsTrading(true)}
                onAccept={() => setIsTrading(false)}
                isPostTrade={isPostTrade}
              />
            )}
            {tradeType === "Sell" && (
              <AssetSaleSelectorForex
                hotActionAsset={tab === "Sell" ? assetToSelect : null}
                awaitingSaleRate={awaitingSaleRate}
                setAwaitingSaleRate={setAwaitingSaleRate}
                setTradeRate={setTradeRate}
                setParentRate={setTradeRate}
                onSelect={handleAssetSaleChange}
                userId={userProfile?._id}
                currencies={currencies}
                setSelectedSaleAsset={setSelectedSaleAsset}
                selectedSaleAsset={selectedSaleAsset}
                fiatBalances={fiatBalances}
              />
            )}
          </div>

          {selectedAsset && !showQuote && !showSuccess && (
            <TradePairForex
              typeOfTrade={tradeType}
              currentPairs={currentPairs}
              selectedAsset={selectedAsset}
              onSelect={handlePairChange}
              onLoadingPair={handleLoadingPair}
              onChange={handleInputAmount}
              setParentRate={setTradeRate}
              awaitingRateParent={awaitingRateParent}
            />
          )}

          {selectedSaleAsset && !showQuote && !showSuccess && (
            <TradePairSaleForex
              typeOfTrade={tradeType}
              currentPairs={currentPairs}
              selectedSaleAsset={selectedSaleAsset}
              onSelect={handlePairsSaleChange}
              onChange={handleInputSaleAmount}
              setIsBaseInputParent={setIsBaseInputParent}
              setParentRate={setTradeRate}
              amount={amount}
              setAmount={setAmount}
              onTarget={handleOrderBuy}
              awaitingSaleRate={awaitingSaleRate}
              setAwaitingSaleRate={setAwaitingSaleRate}
              onTargetCancel={handleOrderCancel}
              onFetchRate={handleDisabledButton}
              onReject={() => setIsTrading(true)}
              onAccept={() => setIsTrading(false)}
              awaitingRateSecondary={awaitingRateSecondary}
              isPostTrade={isPostTrade}
            />
          )}

          {isPostTradeAllowed && !order && isPairPostTradeAllowed && (
            <label className="flex items-center space-x-2 cursor-pointer my-3">
              <input
                type="checkbox"
                checked={isPostTrade}
                onChange={() => setIsPostTrade(!isPostTrade)}
                className="w-5 h-5 accent-rose-600 cursor-pointer border border-gray-100"
              />
              <span className="text-gray-700">
                {tradeType === "Sell" ? "Sell" : "Buy"} using post-trade
                settlement
              </span>
            </label>
          )}
          <div className="border-2 border-gray-100 rounded-lg p-4 flex items-center justify-between mb-6 bg-white">
            <div>
              <p className="font-semibold text-gray-800 mb-1">
                {tradeType === "Sell" ? "Sell" : "Buy"} now, settle later
              </p>
              <p className="text-sm text-gray-600 mb-1">
                Unlock trade opportunities with post trade settlement
              </p>
              <Button
                variant="link"
                className="text-rose-600 text-sm font-semibold p-0"
              >
                Learn more →
              </Button>
            </div>
            <img
              src={pic}
              alt="80eightPay"
              className="w-16 h-16 object-contain"
            />
          </div>
          <Button
            onClick={trade}
            disabled={isTrading}
            className="w-full rounded-full py-6  bg-gradient-to-r from-purple-600 to-pink-500 hover:from-purple-700 hover:to-pink-600"
          >
            {tradeType}{" "}
            {selectedAsset
              ? selectedAsset?.asset.toUpperCase()
              : selectedSaleAsset?.asset.toUpperCase()}
          </Button>
        </Card>
      )}
      {showQuote && !showSuccess && (
        <QuoteDetailsForex
          onBack={handleBack}
          data={quote}
          tradeData={buyData}
          orderData={orderBuyData}
          assetId={selectedAsset?.assetId}
          saleAssetId={selectedSaleAsset?.assetId}
          rate={tradeRate?.rate}
          orderSaleData={orderSellData}
          tradeSellData={sellData}
          typeOfTrade={tradeType}
          isOrder={order}
          onConfirm={handleConfirm}
          isPostTrade={isPostTrade}
          userId={userProfile?._id}
          onRefresh={trade}
        />
      )}
      {loading ? (
        <Skeleton className="w-full max-w-5xl bg-gray-600 rounded-2xl shadow-xl p-12 flex flex-col items-center text-center" />
      ) : showSuccess && !showQuote ? (
        <ForexComplete
          onDone={handleDone}
          isPostTrade={isPostTrade}
          assetName={selectedAsset?.asset?.toUpperCase()}
          tradeType={tradeType}
          sellAssetName={selectedSaleAsset?.asset?.toUpperCase()}
          isOrder={order}
          targetPrice={orderAmount}
          cryptoAmount={incomingAmount}
        />
      ) : null}
    </>
  );
}
